<template>
  <div>
    <div
      class="c-theHeaderAdjust"
      :class="{
        'c-theHeaderAdjust-notFixed': !isHeaderFixed,
        'c-theHeaderAdjust-appBanner': showAppBanner,
        'c-theHeaderAdjust-businessBanner': showBusinessBanner,
        'c-theHeaderAdjust-logoOnlyMode': logoOnlyMode,
        'c-theHeaderAdjust-business': isBusinessHeader,
        'c-theHeaderAdjust-businessSimple': headerType === HEADER_TYPE.BUSINESS_SIMPLE
      }"
    ></div>
    <div
      class="c-theHeader js-fixableHeader"
      :class="{ 'c-theHeader-notFixed': !isHeaderFixed }"
    >
      <AppBanner
        v-if="showAppBanner"
        :app-cookie-key="APP_COOKIE_KEY"
        @closeBanner="setCloseBanner"
      />
      <div
        v-if="showBusinessBanner"
        class="c-theHeader_businessBanner"
      >
        <NuxtLink to="/business/?ref=PC_top_banner_2204">
          <div class="c-theHeader_businessBannerInner">
            <img
              src="@/assets/images/components/TheHeader/business_banner.png"
              width="708"
              height="50"
              alt="coconala Business"
            />
          </div>
        </NuxtLink>
      </div>
      <header
        v-if="headerType === HEADER_TYPE.BUSINESS_SIMPLE"
        class="c-header c-header-businessSimple js-header"
        ref="header"
      >
        <div class="c-header_inner c-header_inner-business">
          <div class="c-logo">
            <CoconalaLogo type="business"></CoconalaLogo>
            <CoconalaLogo type="businessShort"></CoconalaLogo>
          </div>
        </div>
      </header>
      <header
        v-else-if="isBusinessHeader"
        class="c-header c-header-business js-header"
        ref="header"
      >
        <div class="c-header_inner c-header_inner-business">
          <a
            href="javascript:;"
            class="c-header_sidebarToggle js-spMenuButtonGuideTarget"
            v-if="headerType === HEADER_TYPE.BUSINESS"
            @click="showSideBar"
          >
            <CoconalaIcon
              name="bars"
              size="18px"
            />
          </a>
          <div class="c-logo">
            <!-- nuxtの初期化が行われるよう非nuxt-linkにしてある。詳細: https://github.com/welself/web-ui-components/pull/572 -->
            <a :href="headerType === HEADER_TYPE.BUSINESS_BEFORE_LOGIN ? '/business/top' : '/'">
              <CoconalaLogo type="business"></CoconalaLogo>
              <CoconalaLogo type="businessShort"></CoconalaLogo>
            </a>
          </div>
          <div class="c-searchForm c-searchForm-business">
            <DSearchInputBusiness
              @change="doSearch($event)"
              initial-placeholder="キーワードで検索"
              expanded
            />
          </div>
          <div class="c-headerInnerLeft c-headerInner_left">
            <a
              class="c-headerInnerLeft_searchMenu c-headerInnerLeft_searchMenu-business"
              href="javascript:;"
              @click="toggleSearchDrawer"
            >
              <CoconalaIcon
                name="search"
                size="22px"
              />
            </a>

            <MainNavBeforeLogin
              @click-search="toggleSearchDrawer"
              :header-type="headerType"
              v-if="headerType === HEADER_TYPE.BUSINESS_BEFORE_LOGIN"
            />
            <MainNav
              :auth="auth"
              :header-type="headerType"
              @click-search="toggleSearchDrawer"
              @open-user-menu="isOpenUserMenu = true"
              @close-user-menu="isOpenUserMenu = false"
              @click-menu-guide-transaction="clickMenuGuideTransaction"
              v-else
            />
          </div>
        </div>
        <div class="c-subHeader c-subHeader-business">
          <HeaderSub
            :jobs="jobs"
            :blog-categories="blogCategories"
            :master-categories="masterCategories"
            :header-type="headerType"
          />
        </div>
      </header>
      <header
        v-else-if="headerType === HEADER_TYPE.SIMPLE"
        class="c-header js-header c-header-logoOnlyMode"
        ref="header"
      >
        <div class="c-header_inner">
          <div class="c-logo">
            <a href="/">
              <CoconalaLogo type="full"></CoconalaLogo>
              <CoconalaLogo type="simple"></CoconalaLogo>
            </a>
          </div>
        </div>
      </header>
      <header
        v-else
        class="c-header js-header"
        ref="header"
      >
        <div class="c-header_inner">
          <a
            href="javascript:;"
            class="c-header_sidebarToggle js-spMenuButtonGuideTarget"
            v-if="isLoggedIn"
            @click="showSideBar"
          >
            <CoconalaIcon
              name="bars"
              size="18px"
            />
          </a>
          <div class="c-logo">
            <!-- nuxtの初期化が行われるよう非nuxt-linkにしてある。詳細: https://github.com/welself/web-ui-components/pull/572 -->
            <a href="/">
              <CoconalaLogo type="full"></CoconalaLogo>
              <CoconalaLogo type="simple"></CoconalaLogo>
            </a>
          </div>
          <div
            class="c-providerLeft"
            v-if="headerType === HEADER_TYPE.PROVIDER"
          >
            <MainNavProviderLeft
              v-if="headerType === HEADER_TYPE.PROVIDER"
              @click-menu-guide-transaction="clickMenuGuideTransaction"
              @click-menu-guide-pr="clickMenuGuideServicePr"
            />
          </div>
          <div
            class="c-searchForm"
            v-else-if="headerType"
          >
            <DSearchInput
              @change="doSearch($event)"
              @suggest="doSuggest"
              @selectSuggest="sendSuggestSelectLog"
              @clearSuggest="clearSuggest"
              :suggest-result="suggestResult"
              initial-placeholder="キーワードで検索"
              expanded
            />
          </div>
          <div class="c-headerInnerLeft c-headerInner_left">
            <a
              class="c-headerInnerLeft_searchMenu"
              href="javascript:;"
              @click="toggleSearchDrawer"
            >
              <CoconalaIcon
                name="search"
                size="22px"
              />
            </a>
            <MainNavBeforeLogin
              @click-search="toggleSearchDrawer"
              v-if="headerType === HEADER_TYPE.BEFORE_LOGIN"
            />
            <MainNav
              :auth="auth"
              :header-type="headerType"
              @change-header-to-provider="changeHeaderToProvider()"
              @change-header-to-buyer="changeHeaderToBuyer()"
              @click-search="toggleSearchDrawer"
              @open-user-menu="isOpenUserMenu = true"
              @close-user-menu="isOpenUserMenu = false"
              @click-menu-guide-transaction="clickMenuGuideTransaction"
              v-else
            />
          </div>
        </div>
        <div class="c-subHeader">
          <HeaderSub
            :jobs="jobs"
            :blog-categories="blogCategories"
            :master-categories="masterCategories"
            :is-logged-in="isLoggedIn"
            :header-type="headerType"
          />
        </div>
      </header>
    </div>
    <ClientOnly>
      <MainNavSearch
        v-if="isActiveSearchDrawer"
        :header-type="headerType"
        @search="doSearch($event)"
        @close="toggleSearchDrawer(false)"
      />
      <BSidebar
        fullheight
        overlay
        v-model="isActiveSidebar"
      >
        <MenuSidebar
          :auth="auth"
          :header-type="headerType"
          @change-header-to-provider="changeHeaderToProvider('spmenu_change')"
          @change-header-to-buyer="changeHeaderToBuyer('spmenu_change')"
          @change-service-search-collapse="changeServiceSearchCollapse"
          @click-menu-guide-transaction="clickMenuGuideTransaction"
          @click.native="clickSidebar"
        />
      </BSidebar>
      <transition name="fade-in">
        <CoconalaIcon
          name="cross"
          class="c-sidebarClose"
          v-if="isActiveSidebar"
        />
      </transition>

      <div
        class="c-menuGuide-sp"
        v-if="showMenuGuide && isActiveSidebar"
      >
        <MenuGuide
          mode="sp"
          :header-type="headerType"
          :is-sp-service-search-open="isSpServiceSearchOpen"
        />
      </div>

      <div
        class="c-menuGuide-business"
        v-if="showMenuGuideBusiness"
      >
        <MenuGuideBusiness />
      </div>
      <div v-else-if="showMenuGuide">
        <div class="c-menuGuide-pc">
          <MenuGuide
            mode="pc"
            :header-type="headerType"
          />
        </div>
        <div class="c-menuGuide-tb">
          <MenuGuide
            mode="tb"
            :is-open-user-menu="isOpenUserMenu"
            :header-type="headerType"
          />
        </div>
      </div>

      <SpMenuButtonGuideBusiness
        class="c-menuButtonGuide"
        v-if="showMenuGuideBusiness"
        :has-app-banner="showAppBanner"
        :is-active-sidebar="isActiveSidebar"
      />
      <SpMenuButtonGuide
        class="c-menuButtonGuide"
        v-else-if="showMenuGuide && !isActiveSidebar"
        :has-app-banner="showAppBanner"
      />
    </ClientOnly>
  </div>
</template>
<script>
// ヘッダーを固定しないページ
const NOT_FIXED_PAGES = [
  'services-id',
  'blogs-id-blogId',
  'blogs-id-blogId-input',
  'blogs-id-blogId-confirm',
  'blogs-id-blogId-complete',
  'blogs-ss-hashId',
  'talkrooms-talkroomId',
  'talkrooms-talkroomId-information',
  'search',
  'categories-categoryId',
  'categories-categoryId-categoryTypeId'
]

// ヘッダー上にビジネスバナーを表示するページ
const SHOW_BUSINESS_BANNER_PAGES = ['index']

const APP_COOKIE_KEY = 'smart_app_banner_hidden'

import { HEADER_TYPE_COOKIE } from '~/constants/cookie'
import { mapState, mapActions, mapMutations } from 'vuex'

import CoconalaLogo from '~/components/atoms/CoconalaLogo'

export default {
  name: 'TheHeader',
  components: {
    CoconalaLogo,
    AppBanner: () => import('./components/AppBanner' /* webpackChunkName: "AppBanner" */),
    HeaderSub: () => import('./components/HeaderSub' /* webpackChunkName: "HeaderSub" */),
    MainNav: () => import('./components/MainNav' /* webpackChunkName: "MainNav" */),
    MainNavBeforeLogin: () =>
      import('./components/MainNavBeforeLogin' /* webpackChunkName: "MainNavBeforeLogin" */),
    MainNavProviderLeft: () =>
      import('./components/MainNavProviderLeft' /* webpackChunkName: "MainNavProviderLeft" */),
    MainNavSearch: () =>
      import('./components/MainNavSearch' /* webpackChunkName: "MainNavSearch" */),
    MenuSidebar: () => import('./components/MenuSidebar' /* webpackChunkName: "MenuSidebar" */),
    DSearchInput: () =>
      import('~/components/molecules/DS2/DSearchInput' /* webpackChunkName: "DSearchInput" */),
    DSearchInputBusiness: () =>
      import('~/components/molecules/DS2/DSearchInputBusiness' /* webpackChunkName: "DSearchInputBusiness" */),
    MenuGuide: () => import('~/components/organisms/MenuGuide' /* webpackChunkName: "MenuGuide" */),
    MenuGuideBusiness: () =>
      import('~/components/organisms/MenuGuideBusiness' /* webpackChunkName: "MenuGuideBusiness" */),
    SpMenuButtonGuide: () =>
      import('~/components/organisms/SpMenuButtonGuide' /* webpackChunkName: "SpMenuButtonGuide" */),
    SpMenuButtonGuideBusiness: () =>
      import('~/components/organisms/SpMenuButtonGuideBusiness' /* webpackChunkName: "SpMenuButtonGuideBusiness" */)
  },
  props: {
    jobs: {
      type: Array
    },
    masterCategories: {
      type: Array
    },
    blogCategories: {
      type: Array
    },
    auth: {
      type: Object
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      APP_COOKIE_KEY,
      headerType: '',
      isActiveSidebar: false,
      closeAppBanner: false,
      isOpenUserMenu: false,
      isSpServiceSearchOpen: false
    }
  },
  computed: {
    ...mapState('constants', [
      'HEADER_TYPE',
      'HEADER_TYPE_SIMPLE_PAGES',
      'HEADER_TYPE_PROVIDER_ONLY_PAGES',
      'HEADER_TYPE_BUYER_ONLY_PAGES',
      'HEADER_TYPE_BUSINESS_SIMPLE_PAGES'
    ]),
    ...mapState('my/header', [
      'installedApp',
      'isProvider',
      'headerTypeCookie',
      'hasFetchedProvider',
      'privateAccountInfo',
      'isActiveSearchDrawer'
    ]),
    ...mapState('layouts', ['logoOnlyMode']),
    ...mapState('suggest', ['suggestResult']),
    ...mapState('auth/user', ['isBusiness']),
    isHeaderFixed() {
      // ヘッダーを固定しないページの$route.nameをNOT_FIXED_PAGESに記述する
      return NOT_FIXED_PAGES.includes(this.$route.name) ? false : true
    },
    showAppBanner() {
      return (
        this.$ua.isFromSmartphone() &&
        this.$cookies.get(APP_COOKIE_KEY) !== true &&
        !this.installedApp &&
        !this.$route.query.from_ad &&
        !this.closeAppBanner &&
        ![
          this.HEADER_TYPE.SIMPLE,
          this.HEADER_TYPE.BUSINESS_SIMPLE,
          this.HEADER_TYPE.BUSINESS_BEFORE_LOGIN
        ].includes(this.headerType)
      )
    },
    showMenuGuideBusiness() {
      if (
        [this.HEADER_TYPE.PROVIDER, this.HEADER_TYPE.BUYER, this.HEADER_TYPE.BUSINESS].includes(
          this.headerType
        ) &&
        this.$route.query.account_linked === '1'
      ) {
        return true
      }

      if (
        this.headerType === this.HEADER_TYPE.BUSINESS &&
        this.$route.query.account_completed_questionnaire === '1' &&
        Object.keys(this.privateAccountInfo).length
      ) {
        return true
      }

      return false
    },
    showMenuGuide() {
      return (
        [this.HEADER_TYPE.PROVIDER, this.HEADER_TYPE.BUYER].includes(this.headerType) &&
        !this.showMenuGuideBusiness // ビジネスのガイドの方が優先
      )
    },
    isBusinessHeader() {
      return (
        this.headerType === this.HEADER_TYPE.BUSINESS ||
        this.headerType === this.HEADER_TYPE.BUSINESS_BEFORE_LOGIN
      )
    },
    showBusinessBanner() {
      return (
        !this.isBusinessHeader &&
        !this.isLoggedIn &&
        SHOW_BUSINESS_BANNER_PAGES.includes(this.$route.name)
      )
    }
  },
  watch: {
    $route() {
      this.setHeaderType()
    },
    logoOnlyMode() {
      this.setHeaderType()
    },
    isActiveSidebar(newVal) {
      this.$util.bodyScrollPrevent(newVal)
    }
  },
  async fetch() {
    if (this.isLoggedIn && this.$ua.isFromSmartphone()) {
      await this.fetchHeader()
    } else {
      this.$store.commit('my/header/FALSE_INSTALLED_APP')
    }
    await this.setHeaderType()
  },
  mounted() {
    if (this.isLoggedIn) {
      this.fetchHeader()
    }
    // 人気のご利用シーン取得
    this.$store.dispatch('master/getUseScenes').catch(() => {})
  },
  methods: {
    ...mapActions('menu_guide', [
      'setFinishedModeChangeScene',
      'setFinishedTransactionScene',
      'setFinishedServicePrScene'
    ]),
    ...mapActions('sp_menu_guide', ['setSpMenuButtonGuideScene']),
    ...mapMutations('my/header', ['TOGGLE_SEARCH_DRAWER']),
    async fetchHeader() {
      if (!this.hasFetchedProvider) {
        // TODO: エラー時Sentryに送信
        await this.$store.dispatch('my/fetchHeader')
      }
    },
    doSearch({ searchType, searchAttributes }) {
      let url = null
      const option = { keyword: searchAttributes.searchText }
      if (searchAttributes.searchCategoryId) {
        option.category_id = searchAttributes.searchCategoryId
      }
      if (searchType === 'service') {
        url = this.$coconala.rootPathUrl('/search', option)
      } else if (searchType === 'user') {
        url = this.$coconala.rootPathUrl('/users/search', option)
      } else if (searchType === 'request') {
        url = this.$coconala.rootPathUrl('/requests', option)
      } else {
        if (option.keyword) {
          url = this.$coconala.rootPathUrl('/blogs/search', option)
        } else {
          // SEO上、末尾をスラッシュにする
          url = '/blogs/'
        }
      }
      if (this.headerType === this.HEADER_TYPE.BUSINESS_BEFORE_LOGIN) {
        url += url.indexOf('?') === -1 ? '?is_business=1' : '&is_business=1'
      }
      // 検索条件を強制リセットするためlocation.hrefにする
      location.href = url
    },
    async doSuggest(keyword) {
      await this.$store.dispatch('suggest/fetchSuggest', { keyword })
    },
    async sendSuggestSelectLog(params) {
      await this.$store.dispatch('suggest/sendSuggestSelectLog', params)
    },
    clearSuggest() {
      this.$store.dispatch('suggest/clearSuggest')
    },
    setCloseBanner() {
      this.closeAppBanner = true
    },
    async setHeaderType() {
      if (this.$route.name === 'switch_account' && !this.isBusiness) {
        this.headerType = this.HEADER_TYPE.SIMPLE
        return
      }

      if (
        this.HEADER_TYPE_BUSINESS_SIMPLE_PAGES?.some(name => this.$route.name?.startsWith(name))
      ) {
        this.headerType = this.HEADER_TYPE.BUSINESS_SIMPLE
        return
      }

      if (this.isBusiness) {
        if (this.logoOnlyMode || this.HEADER_TYPE_SIMPLE_PAGES?.includes(this.$route.name)) {
          // シンプルヘッダーのページは、ビジネスアカウントの場合ビジネスシンプルヘッダーを表示
          this.headerType = this.HEADER_TYPE.BUSINESS_SIMPLE
          return
        }

        this.headerType = this.HEADER_TYPE.BUSINESS
        return
      }

      if (this.$route.name === 'business-top' || this.$route.query.is_business) {
        // ビジネスプレビューモード
        this.headerType = this.HEADER_TYPE.BUSINESS_BEFORE_LOGIN
        return
      }

      if (this.logoOnlyMode || this.HEADER_TYPE_SIMPLE_PAGES?.includes(this.$route.name)) {
        this.headerType = this.HEADER_TYPE.SIMPLE
        return
      }

      if (!this.isLoggedIn) {
        this.headerType = this.HEADER_TYPE.BEFORE_LOGIN
        return
      }

      if (this.HEADER_TYPE_PROVIDER_ONLY_PAGES?.includes(this.$route.name)) {
        this.setCookieHeaderTypeProvider()
        this.headerType = this.HEADER_TYPE.PROVIDER
        return
      }

      if (this.HEADER_TYPE_BUYER_ONLY_PAGES?.includes(this.$route.name)) {
        this.setCookieHeaderTypeBuyer()
        this.headerType = this.HEADER_TYPE.BUYER
        return
      }

      const headerTypeCookie = this.$cookies.get(HEADER_TYPE_COOKIE.NAME) || ''
      if (!headerTypeCookie) {
        await this.fetchHeader()

        if (this.isProvider) {
          this.setCookieHeaderTypeProvider()
          this.headerType = this.HEADER_TYPE.PROVIDER
          return
        }

        this.setCookieHeaderTypeBuyer()
        this.headerType = this.HEADER_TYPE.BUYER
        return
      }

      if (headerTypeCookie === HEADER_TYPE_COOKIE.VALUE_PROVIDER) {
        this.headerType = this.HEADER_TYPE.PROVIDER
        return
      }

      this.headerType = this.HEADER_TYPE.BUYER
    },
    async changeHeaderToBuyer(ref = 'header_change') {
      this.setFinishedModeChangeScene()
      this.setCookieHeaderTypeBuyer()
      location.href = '/?ref=' + ref
    },
    async changeHeaderToProvider(ref = 'header_change') {
      this.setFinishedModeChangeScene()
      this.setCookieHeaderTypeProvider()
      location.href = '/mypage/dashboard_provider?ref=' + ref
    },
    changeServiceSearchCollapse(isOpen) {
      this.isSpServiceSearchOpen = isOpen
    },
    setCookieHeaderTypeProvider() {
      this.$store.commit('my/header/SET_COOKIE_HEADER_TYPE_PROVIDER')
    },
    setCookieHeaderTypeBuyer() {
      this.$store.commit('my/header/SET_COOKIE_HEADER_TYPE_BUYER')
    },
    clickSidebar(event) {
      // サイドバーのリンクまたは特定のクラスをクリックしたらサイドバーを閉じる
      if (event.target.nodeName === 'A' || event.target.classList.contains('js-closeSidebar')) {
        this.isActiveSidebar = false
      }
    },
    clickMenuGuideTransaction() {
      this.setFinishedTransactionScene()
    },
    clickMenuGuideServicePr() {
      this.setFinishedServicePrScene()
    },
    toggleSearchDrawer(flag = null) {
      this.TOGGLE_SEARCH_DRAWER(flag)
      this.$util.bodyScrollPrevent(flag)
    },
    showSideBar() {
      this.setSpMenuButtonGuideScene('complete')
      this.isActiveSidebar = true
    }
  }
}
</script>
<style lang="scss" scoped>
$header-height: 100px;
$header-height-business: 108px;
$header-height-business-simple: 72px;
$logo-only-mode-height: 60px;
$business-banner-height: 50px;
$header-height-business-banner: $header-height + $business-banner-height;

.c-theHeaderAdjust {
  height: $header-height;

  &-business {
    height: $header-height-business;
  }

  &-businessSimple {
    height: $header-height-business-simple;
  }

  &-notFixed {
    display: none;
  }

  &-logoOnlyMode {
    height: $logo-only-mode-height;
  }

  &-businessBanner {
    height: $header-height-business-banner;
  }
}

.c-theHeader {
  position: fixed;
  top: 0;
  z-index: z(header, main);
  width: 100%;

  &_businessBanner {
    height: $business-banner-height;
    background-color: $ds2-color-white;
  }

  &_businessBannerInner {
    @include link-effect;

    width: 100vw;
    height: 50px;
    background: linear-gradient(to right bottom, #212d94, #0a115a);
    text-align: center;
  }

  &-notFixed {
    position: relative;
  }
}

.c-header {
  width: 100%;
  height: $header-height;
  background-color: $ds2-color-white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

  .c-logo {
    min-width: 140px;
    max-width: 140px;
    width: 140px;
    height: 33px;

    /deep/ .c-logo {
      &.-is-simple {
        display: none;
      }

      &.-is-businessShort {
        display: none;
      }
    }
  }

  &-business,
  &-businessSimple {
    height: $header-height-business;
    background-color: $ds2-color-business-navy-1000;
    box-shadow: 0 4px 4px rgba(56, 41, 42, 0.05);

    .c-logo {
      min-width: 267px;
      max-width: 267px;
      width: 267px;
      height: 26px;

      /deep/ .c-logo {
        &.-is-businessShort {
          display: none;
        }
      }
    }
  }

  &-businessSimple {
    height: $header-height-business-simple;
  }

  &_inner {
    position: relative;
    display: flex;
    margin: auto;
    padding: 0 24px;
    max-width: $breakpoint-xl;
    height: 60px;

    align-items: center;

    &-business {
      height: 72px;
    }
  }

  &_sidebarToggle {
    display: none;
  }

  &-logoOnlyMode {
    height: $logo-only-mode-height;
  }
}

.c-searchForm {
  flex: 1;
  margin-left: 20px;
  max-width: 396px;

  &-business {
    margin-left: 28px;
  }
}

.c-headerInner {
  &_left {
    margin-left: auto;
  }
}

.c-headerInnerLeft {
  display: flex;

  align-items: center;

  &_searchMenu {
    @include link-effect-background;

    display: none;
    margin-left: 20px;
    color: $ds2-color-gray-600;
    transform: translateY(1px);

    &-business {
      @include link-effect-background-business;

      color: $ds2-color-gray-25;
    }
  }
}

// NOTE: サービス検索ページのみのイレギュラー対応
// ・pages/search/searchService.vueを読み込んでいるページでbodyにsearchServiceクラスが付加される
// ・サービス検索の左カラムが消えるタイミングでヘッダの検索メニューを表示
// ・SP判定時では検索メニューが重複してしまうので非表示
body.searchService {
  .c-searchForm {
    display: none;
  }

  .c-headerInnerLeft {
    &_searchMenu {
      display: flex;
    }
  }

  @media (min-width: breakpoint(Search, M) + 1px) {
    .c-searchForm {
      display: block;
    }

    .c-headerInnerLeft {
      &_searchMenu {
        display: none;
      }
    }
  }

  @media (max-width: breakpoint(Header, S)) {
    .c-headerInnerLeft {
      &_searchMenu {
        display: none;
      }
    }
  }
}

.c-subHeader {
  border-top: 1px solid $ds2-color-gray-10;
  background-color: $ds2-color-white;

  &-business {
    border-top: 0;
  }
}

.b-sidebar {
  z-index: z(modal, wrapper);

  /deep/ .sidebar-background {
    z-index: z(modal, overlay);
    background-color: rgba(0, 0, 0, 0.7);
  }

  /deep/ .sidebar-content {
    z-index: z(modal, wrapper);
    width: 284px;
    background-color: $ds2-color-white;
  }
}

.c-sidebarClose {
  position: fixed;
  top: 32px;
  left: 300px;
  z-index: z(modal, wrapper);
  color: $ds2-color-white;
}

.c-menuGuide {
  &-business {
    display: block;
  }
  &-pc {
    display: block;
  }
  &-tb {
    display: none;
  }
  &-sp {
    display: none;
  }
}
.c-menuButtonGuide {
  display: none;
}

@media (max-width: breakpoint(Header, M)) {
  .c-header {
    &-business,
    &-businessSimple {
      .c-logo {
        min-width: 137px;
        max-width: 137px;
        width: 137px;
        height: 26px;

        /deep/ .c-logo {
          &.-is-business {
            display: none;
          }
          &.-is-businessShort {
            display: block;
          }
        }
      }
    }
  }

  .c-menuGuide {
    &-business {
      display: block;
    }
    &-pc {
      display: none;
    }
    &-tb {
      display: block;
    }
    &-sp {
      display: none;
    }
  }
  .c-menuButtonGuide {
    display: none;
  }
}

@media (max-width: breakpoint(Header, S)) {
  $header-height-app-banner: 133px;
  $header-height: 48px;

  .c-providerLeft,
  .c-searchForm {
    display: none;
  }

  .c-theHeaderAdjust {
    height: $header-height;

    &-appBanner {
      height: $header-height-app-banner;
    }
  }

  .c-theHeader {
    &_businessBanner {
      display: none;
    }
  }

  .c-subHeader {
    display: none;
  }

  .c-header {
    height: $header-height;
    border-bottom: 1px solid $ds2-color-gray-50;
    box-shadow: none;

    .c-logo {
      min-width: 116px;
      max-width: 116px;
      width: 116px;
      height: 30px;

      /deep/ .c-logo {
        &.-is-full {
          display: none;
        }
        &.-is-simple {
          display: block;
        }
      }
    }

    &_inner {
      padding: 0 12px;
      height: 100%;
    }

    &_sidebarToggle {
      display: block;
      margin-right: 12px;
      color: $ds2-color-gray-600;

      .coconala-icon {
        vertical-align: -5px;
      }
    }

    &-business,
    &-businessSimple {
      border-bottom: 0;

      .c-logo {
        min-width: 112px;
        max-width: 112px;
        width: 112px;
        height: 21px;
      }

      .c-header {
        &_sidebarToggle {
          color: $ds2-color-gray-25;
        }
      }
    }
  }

  .c-menuGuide {
    &-business {
      display: none;
    }
    &-pc {
      display: none;
    }
    &-tb {
      display: none;
    }
    &-sp {
      display: block;
    }
  }

  .c-menuButtonGuide {
    display: block;
  }
}
</style>
